/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (display objects) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
import { HEIGHT, WIDTH } from '~/lib/stage'
import { deepFreeze } from '~/lib/deepFreeze'

export const display_object_schema = deepFreeze({
	$id: 'display_object',
	definitions: {
		brush: {
			$id: 'brush',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'brush',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				fill: {
					type: ['string', 'object'],
					initial: '#000000',
					tip: 'Fill color',
					kind: 'fill',
					label: 'Fill',
				},
				stroke: {
					type: ['string', 'null'],
					initial: '',
					tip: 'Stroke color',
					kind: 'color',
					label: 'Stroke',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				data: {
					type: 'string',
					initial: '',
				},
				centerline: {
					type: 'string',
					initial: '',
				},
				rawPoints: {
					type: 'string',
					initial: '',
				},
				strokeCap: {
					type: 'string',
					initial: 'round',
					enum: ['round', 'butt'],
					tip: 'Stroke cap',
					kind: 'select',
					label: 'Cap',
				},
				widthProfile: {
					type: 'string',
					initial: 'diamond',
					enum: ['diamond', 'grow', 'shrink'],
					tip: 'Width profile',
					kind: 'select',
					label: 'Profile',
				},
				smoothness: {
					type: 'integer',
					initial: 50,
					minimum: 0,
					maximum: 100,
					step: 1,
					tween: false,
					tip: 'Smoothness',
					natural_step: 10,
					label: 'Smoothness',
				},
				minWidth: {
					type: 'number',
					initial: 20,
					minimum: 0,
					maximum: 120,
					step: 1,
					tween: false,
					tip: 'Base width at edges',
					label: 'Min Width',
				},
				widthGrowth: {
					type: 'number',
					minimum: 0,
					initial: 8,
					maximum: 120,
					tween: false,
					tip: 'Growth above base width',
					label: 'Growth',
				},
				variableWidth: {
					type: 'boolean',
					initial: false,
				},
				inpaint_mask: {
					type: 'boolean',
					initial: false,
					label: 'Inpaint',
					tip: 'Use for diffusion mask',
				},
				role: {
					type: 'string',
					initial: 'draw',
					enum: ['draw', 'region'],
					tip: 'Role',
					kind: 'select',
				},
				map: {
					type: ['string', 'object'],
					initial: '',
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y'],
			icon: 'ms/brush',
		},
		rect: {
			$id: 'rect',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'rect',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				fill: {
					type: ['string', 'object'],
					initial: '#000000',
					tip: 'Fill color',
					kind: 'fill',
					label: 'Fill',
				},
				stroke: {
					type: ['string', 'null'],
					initial: '',
					tip: 'Stroke color',
					kind: 'color',
					label: 'Stroke',
				},
				strokeWidth: {
					type: 'number',
					minimum: 0,
					initial: 1,
					maximum: 40,
					tip: 'Stroke width',
					label: 'Stroke Width',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				scaleX: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				scaleY: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				role: {
					type: 'string',
					initial: 'draw',
					enum: ['draw', 'region'],
					tip: 'Role',
					kind: 'select',
				},
				map: {
					type: ['string', 'object'],
					initial: '',
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y', 'width', 'height'],
			icon: 'ms/crop_square',
		},
		circle: {
			$id: 'circle',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'circle',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				fill: {
					type: ['string', 'object'],
					initial: '#000000',
					tip: 'Fill color',
					kind: 'fill',
					label: 'Fill',
				},
				stroke: {
					type: ['string', 'null'],
					initial: '',
					tip: 'Stroke color',
					kind: 'color',
					label: 'Stroke',
				},
				strokeWidth: {
					type: 'number',
					minimum: 0,
					initial: 1,
					maximum: 40,
					tip: 'Stroke width',
					label: 'Stroke Width',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				scaleX: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				scaleY: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				role: {
					type: 'string',
					initial: 'draw',
					enum: ['draw', 'region'],
					tip: 'Role',
					kind: 'select',
				},
				map: {
					type: ['string', 'object'],
					initial: '',
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y', 'width', 'height'],
			icon: 'ms/circle',
		},
		path: {
			$id: 'path',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'path',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				fill: {
					type: ['string', 'object'],
					initial: '#000000',
					tip: 'Fill color',
					kind: 'fill',
					label: 'Fill',
				},
				stroke: {
					type: ['string', 'null'],
					initial: '',
					tip: 'Stroke color',
					kind: 'color',
					label: 'Stroke',
				},
				strokeWidth: {
					type: 'number',
					minimum: 0,
					initial: 1,
					maximum: 40,
					tip: 'Stroke width',
					label: 'Stroke Width',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				scaleX: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				scaleY: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				data: {
					type: 'string',
					initial: '',
				},
				inpaint_mask: {
					type: 'boolean',
					initial: false,
					label: 'Inpaint',
					tip: 'Use for diffusion mask',
				},
				role: {
					type: 'string',
					initial: 'draw',
					enum: ['draw', 'region'],
					tip: 'Role',
					kind: 'select',
				},
				map: {
					type: ['string', 'object'],
					initial: '',
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y'],
			icon: 'ms/pentagon',
		},
		image: {
			$id: 'image',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'image',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				scaleX: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				scaleY: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				source: {
					type: 'string',
					initial: '',
				},
				eraserMask: {
					type: 'string',
					initial: '',
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y', 'width', 'height'],
			icon: 'ms/image',
		},
		root: {
			$id: 'root',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				type: {
					const: 'root',
				},
				fill: {
					type: ['string', 'object'],
					initial: '#000000',
					tip: 'Fill color',
					kind: 'fill',
					label: 'Fill',
				},
				children: {
					type: 'array',
					readOnly: true,
				},
			},
		},
		group: {
			$id: 'group',
			type: 'object',
			properties: {
				id: {
					type: 'string',
					readOnly: true,
				},
				parentId: {
					type: 'string',
					initial: '',
				},
				type: {
					const: 'group',
				},
				visible: {
					type: 'boolean',
					initial: true,
					onIcon: 'rx/eye_open',
					offIcon: 'rx/eye_closed',
				},
				opacity: {
					type: 'number',
					minimum: 0,
					maximum: 100,
					initial: 100,
					step: 1,
					tip: 'Opacity',
					natural_step: 10,
					label: 'Opacity',
				},
				locked: {
					type: 'boolean',
					initial: false,
					onIcon: 'rx/lock_closed',
					offIcon: 'rx/lock_open',
				},
				zIndex: {
					type: 'integer',
					initial: 0,
					step: 1,
				},
				x: {
					type: 'number',
					initial: 0,
					minimum: -1800,
					maximum: 2800,
					step: 1,
					tip: 'X position',
				},
				y: {
					type: 'number',
					initial: 0,
					minimum: -1000,
					maximum: 2000,
					step: 1,
					tip: 'Y position',
				},
				rotation: {
					type: 'number',
					initial: 0,
					maximum: 360,
					minimum: 0,
					wrap: true,
					unit: '°',
					tip: 'Rotation',
					label: 'Rotation',
				},
				pivotX: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				pivotY: {
					type: 'number',
					initial: 0.5,
					step: 0.000001,
				},
				mask: {
					type: 'string',
					initial: '',
				},
				maskInverse: {
					type: 'boolean',
					initial: false,
				},
				blendMode: {
					type: 'string',
					initial: 'source-over',
					enum: ['source-over', 'destination-in', 'destination-out', 'lighter'],
					tip: 'Blend mode',
					kind: 'select',
					label: 'Blend Mode',
				},
				width: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 3600,
					tween: false,
					label: 'Width',
					tip: 'Width',
				},
				height: {
					type: 'number',
					initial: 100,
					minimum: 0,
					maximum: 2000,
					tween: false,
					label: 'Height',
					tip: 'Height',
				},
				scaleX: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				scaleY: {
					type: 'number',
					initial: 1,
					minimum: -40,
					maximum: 40,
					step: 0.000001,
					natural_step: 0.1,
				},
				children: {
					type: 'array',
					readOnly: true,
					items: {
						type: 'string',
					},
				},
			},
			required: ['id', 'type', 'parentId', 'x', 'y'],
			icon: 'ms/folder',
		},
	},
})

const definitions = Object.values(display_object_schema.definitions)

export const display_objects_array_schema = {
	type: 'array',
	items: {
		oneOf: definitions,
	},
}

export default display_object_schema
